import React from 'react'
import PropTypes from 'prop-types'
import { ButtonV3 } from '@provi/provi-components'
import {
  CashPaymentContainer,
  CashPaymentLabel,
  PriceDisplay,
  PriceValue,
  DiscountBadge,
  DiscountIcon,
  DiscountText,
  ValidityText,
  ButtonWrapper
} from './styles'
import { Skeleton, BadgeSkeleton, ButtonSkeleton } from '../Skeleton'
import { InfoBanner } from '../InfoBanner'

const PriceTagIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.75 1.5L11.25 6L6.75 10.5L2.25 6L6.75 1.5Z" fill="white" />
    <circle cx="6.75" cy="6" r="1" fill="#14B8AA" />
  </svg>
)

const CashPaymentSkeleton = () => (
  <CashPaymentContainer>
    <Skeleton width="280px" height="18px" style={{ marginBottom: '16px' }} />
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
      <Skeleton width="180px" height="36px" borderRadius="6px" />
      <BadgeSkeleton width="220px" />
      <Skeleton width="200px" height="14px" />
    </div>
    <ButtonSkeleton height="40px" />
  </CashPaymentContainer>
)

export const CashPaymentSection = ({ isLoading, totalValue, discountValue, validityDate, onAccept }) => {
  if (isLoading) {
    return <CashPaymentSkeleton />
  }

  return (
    <CashPaymentContainer>
      <CashPaymentLabel>Valor total para quitação à vista:</CashPaymentLabel>

      <PriceDisplay>
        <PriceValue>{totalValue}</PriceValue>

        {discountValue && (
          <DiscountBadge>
            <DiscountIcon>
              <PriceTagIcon />
            </DiscountIcon>
            <DiscountText>Desconto de {discountValue} já aplicado</DiscountText>
          </DiscountBadge>
        )}

        {validityDate && <ValidityText>Validade da proposta {validityDate}</ValidityText>}
        <InfoBanner isLoading={isLoading} show={true} />
      </PriceDisplay>

      <ButtonWrapper>
        <ButtonV3
          text="Aceitar proposta"
          width="100%"
          mobileWidth="100%"
          height="40px"
          onClick={onAccept}
          disabled={isLoading}
        />
      </ButtonWrapper>
    </CashPaymentContainer>
  )
}

CashPaymentSection.propTypes = {
  isLoading: PropTypes.bool,
  totalValue: PropTypes.string,
  discountValue: PropTypes.string,
  validityDate: PropTypes.string,
  onAccept: PropTypes.func
}

CashPaymentSection.defaultProps = {
  isLoading: false,
  totalValue: '-',
  discountValue: null,
  validityDate: null,
  onAccept: () => {}
}
